import {triggerAdvanceCashierEvent} from "./trigger-advance-cashier-event";

export const cashierLoaded = (data) => {
    triggerAdvanceCashierEvent({
        event_type: 'cashier_loaded',
        ...data
    })
}